import React, { useEffect, useState } from "react";
import { adminApi } from "../api/adminApi";
import AdminCard from "../components/AdminCard";

export default function AdminRoleRequestsPage() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    const loadItems = async () => {
        try {
            setLoading(true);
            const data = await adminApi.getRoleRequests();
            setItems(data);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadItems();
    }, []);

    const approve = async (id) => {
        await adminApi.approveRoleRequest(id);
        loadItems();
    };

    const reject = async (id) => {
        await adminApi.rejectRoleRequest(id);
        loadItems();
    };

    return (
        <div style={{ padding: 20 }}>
            <AdminCard
                title="Rollen-Anträge"
                subtitle="Offene Anträge für Trading.View prüfen."
            >
                {loading ? (
                    <div>Lade …</div>
                ) : items.length === 0 ? (
                    <div>Keine offenen Rollen-Anträge vorhanden.</div>
                ) : (
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr>
                                <th style={th}>Benutzer</th>
                                <th style={th}>E-Mail</th>
                                <th style={th}>Rolle</th>
                                <th style={th}>Beantragt am</th>
                                <th style={th}>Aktionen</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((r) => (
                                <tr key={r.id}>
                                    <td style={td}>{r.user.userName}</td>
                                    <td style={td}>{r.user.email}</td>
                                    <td style={td}>{r.roleName}</td>
                                    <td style={td}>
                                        {new Date(r.requestedAt).toLocaleString("de-DE")}
                                    </td>
                                    <td style={td}>
                                        <button style={btnOk} onClick={() => approve(r.id)}>
                                            Genehmigen
                                        </button>
                                        <button style={btnNo} onClick={() => reject(r.id)}>
                                            Ablehnen
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </AdminCard>
        </div>
    );
}

const th = {
    textAlign: "left",
    padding: "10px 12px",
    borderBottom: "1px solid #cbd5e1"
};

const td = {
    padding: "10px 12px",
    borderBottom: "1px solid #e2e8f0"
};

const btnOk = {
    background: "#16a34a",
    color: "white",
    border: "none",
    borderRadius: 6,
    padding: "6px 12px",
    cursor: "pointer",
    marginRight: 8
};

const btnNo = {
    background: "#dc2626",
    color: "white",
    border: "none",
    borderRadius: 6,
    padding: "6px 12px",
    cursor: "pointer"
};